import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {LogoutIcon, SettingsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IProfileMenuItem} from "../config/profile_menu_items";
import {navigationItemActiveStyle, navigationItemHoverStyle} from "../constants/navigation_shared_styles";
import {useProfileMenuItems} from "../hooks/use_profile_menu_items";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";

interface IProps {
    onLogout: () => void;
    onNavigate: (item: IProfileMenuItem) => void;
    preferencesCta?: ReactNode;
}

export const UserProfileMenuItems = (props: IProps) => {
    const {onLogout, onNavigate, preferencesCta} = props;
    const {logoutItem, standardMenuItems} = useProfileMenuItems();

    return (
        <>
            {preferencesCta}

            {standardMenuItems.map((item) => {
                if (!item.path) return null;

                return (
                    <NavigationLinkItem
                        activeClassName={navigationItemActiveStyle}
                        className={menuItemClassName}
                        dataTestId={item.testId}
                        key={item.itemId}
                        onNavigate={() => onNavigate(item)}
                        to={item.path}
                    >
                        <SettingsIcon size="2" />
                        <Text variant="info_txt_1">{item.label}</Text>
                    </NavigationLinkItem>
                );
            })}

            <Button
                className={cx(profileMenuItemStyle, navigationItemHoverStyle, profileMenuLogoutButtonStyle)}
                dataTestId={logoutItem.testId}
                fullWidth
                iconLeft={() => <LogoutIcon size="2" />}
                onClick={onLogout}
                type="button"
                variant="none_secondary"
            >
                {logoutItem.label}
            </Button>
        </>
    );
};

const profileMenuItemStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 2,
    width: "100%",
    px: 2,
    height: "4.4rem",
    minHeight: "unset",
    transition: "background-color var(--transition-duration-fast) var(--transition-timingFunction)"
});

const profileMenuLogoutButtonStyle = css({
    borderRadius: 0,
    "& > span": {
        justifyContent: "flex-start",
        gap: 2,
        width: "100%"
    },
    "& > span > *:last-child": {
        fontWeight: 400,
        fontSize: "1.067rem",
        lineHeight: "1.2rem",
        textTransform: "none",
        letterSpacing: "normal",
        md: {
            fontSize: "1.244rem",
            lineHeight: "1.6rem"
        }
    }
});

const menuItemClassName = cx(profileMenuItemStyle, navigationItemHoverStyle, navigationLinkItemResetStyle);
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {LogoutIcon, SettingsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IProfileMenuItem} from "../config/profile_menu_items";
import {navigationItemActiveStyle, navigationItemHoverStyle} from "../constants/navigation_shared_styles";
import {useProfileMenuItems} from "../hooks/use_profile_menu_items";
import {NavigationLinkItem, navigationLinkItemResetStyle} from "./NavigationLinkItem";

interface IProps {
    onLogout: () => void;
    onNavigate: (item: IProfileMenuItem) => void;
    preferencesCta?: ReactNode;
}

export const UserProfileMenuItems = (props: IProps) => {
    const {onLogout, onNavigate, preferencesCta} = props;
    const {logoutItem, standardMenuItems} = useProfileMenuItems();

    return (
        <>
            {preferencesCta}

            {standardMenuItems.map((item) => {
                if (!item.path) return null;

                return (
                    <NavigationLinkItem
                        activeClassName={navigationItemActiveStyle}
                        className={menuItemClassName}
                        dataTestId={item.testId}
                        key={item.itemId}
                        onNavigate={() => onNavigate(item)}
                        to={item.path}
                    >
                        <SettingsIcon size="2" />
                        <Text variant="info_txt_1">{item.label}</Text>
                    </NavigationLinkItem>
                );
            })}

            <Button
                className={cx(profileMenuItemStyle, navigationItemHoverStyle, profileMenuLogoutButtonStyle)}
                dataTestId={logoutItem.testId}
                fullWidth
                iconLeft={() => <LogoutIcon size="2" />}
                onClick={onLogout}
                type="button"
                variant="none_secondary"
            >
                {logoutItem.label}
            </Button>
        </>
    );
};

const profileMenuItemStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 2,
    width: "100%",
    px: 2,
    height: "4.4rem",
    minHeight: "unset",
    transition: "background-color var(--transition-duration-fast) var(--transition-timingFunction)"
});

const profileMenuLogoutButtonStyle = css({
    borderRadius: 0,
    "& > span": {
        justifyContent: "flex-start",
        gap: 2,
        width: "100%"
    },
    "& > span > *:last-child": {
        fontWeight: 400,
        fontSize: "1.067rem",
        lineHeight: "1.2rem",
        textTransform: "none",
        letterSpacing: "normal",
        md: {
            fontSize: "1.244rem",
            lineHeight: "1.6rem"
        }
    }
});

const menuItemClassName = cx(profileMenuItemStyle, navigationItemHoverStyle, navigationLinkItemResetStyle);
